import { z } from 'zod';
import { INSTRUMENT_TYPE } from '@fortem-monorepo/constants';
import { baseStructuredSchema } from './shared/base-structured.schema';
import { contractSideSchema } from './shared/contract-side.schema';
import { contractTypeSchema } from './shared/contract-type.schema';
import { knockdownInputLevelSchema } from './shared/knockdown-input-level.schema';
export const vanillaSpreadSchema = baseStructuredSchema.extend({
    instrument_type: z.literal(INSTRUMENT_TYPE.VanillaSpread),
    contract_side: contractSideSchema,
    contract_type: contractTypeSchema,
    participation_rate: z.number(),
    knockdown_input_level: knockdownInputLevelSchema,
});
